import * as React from 'react';

export const ESCAPE_KEY = 'Escape';

const useKeyPress = (
  targetKey: string,
  callback: () => void,
  ref?: React.RefObject<HTMLElement>
): void => {
  const handleKey = (event: KeyboardEvent) => {
    if (event.key === targetKey) {
      if (!ref || (ref.current && ref.current.contains(document.activeElement))) {
        callback();
      }
    }
  };

  React.useEffect(() => {
    document.addEventListener('keyup', handleKey);

    return () => {
      document.removeEventListener('keyup', handleKey);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ref, callback]);
};

export default useKeyPress;
